// extracted by mini-css-extract-plugin
export default {"wrapper":"acl_wrapper__IBF+7","header":"acl_header__i48ca","content":"acl_content__71z1E"};